import { render, staticRenderFns } from "./modal-popup.vue?vue&type=template&id=b1fde8f6&scoped=true&"
import script from "./modal-popup.vue?vue&type=script&lang=js&"
export * from "./modal-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fde8f6",
  null
  
)

export default component.exports